/* Independent of vendor/theme.js. Keep the poster until a decoded video frame
 * is ready, and clean up work when the Theme Editor removes a section. */
(() => {
  if (window.flycatcherHeroMediaInstalled) return;
  window.flycatcherHeroMediaInstalled = true;
  const selector = 'video[data-flycatcher-hero-video]';
  const states = new Map();

  function initialize(root) {
    const videos = [];
    if (root.matches && root.matches(selector)) videos.push(root);
    if (root.querySelectorAll) videos.push(...root.querySelectorAll(selector));
    videos.forEach(video => {
      if (states.has(video)) return;
      const poster = video.parentElement.querySelector('.flycatcher-hero-poster');
      const controller = new AbortController();
      const state = { stopped: false, started: false, observer: null, frame: 0, videoFrame: null };
      states.set(video, state);
      const listen = (target, name, callback, options = {}) => {
        target.addEventListener(name, callback, { ...options, signal: controller.signal });
      };
      function reveal() {
        state.videoFrame = null;
        if (!state.stopped && poster) poster.hidden = true;
      }
      listen(video, 'playing', () => {
        if (state.videoFrame !== null && video.cancelVideoFrameCallback) {
          video.cancelVideoFrameCallback(state.videoFrame);
        }
        if (typeof video.requestVideoFrameCallback === 'function') {
          state.videoFrame = video.requestVideoFrameCallback(reveal);
        } else if (video.readyState >= 2) {
          reveal();
        }
      });
      listen(video, 'error', () => {
        if (poster && video.autoplay) poster.hidden = false;
      });
      if (!video.autoplay) reveal();

      function start() {
        state.frame = 0;
        if (state.started || state.stopped || !video.isConnected) return;
        state.started = true;
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
        if (video.autoplay) {
          const playing = video.play();
          if (playing && playing.catch) playing.catch(() => {
            if (!state.stopped) {
              video.controls = true;
              // The native poster uses the same URL and leaves controls visible.
              reveal();
            }
          });
        }
      }
      function afterPoster() {
        if (state.stopped) return;
        // Yield two frames so the poster can paint before video loading starts.
        state.frame = requestAnimationFrame(() => {
          if (!state.stopped) state.frame = requestAnimationFrame(start);
        });
      }
      function prepare() {
        if (!video.poster) { afterPoster(); return; }
        const image = poster || new Image();
        let finished = false;
        const finish = () => {
          if (finished || state.stopped) return;
          finished = true;
          if (image.naturalWidth && typeof image.decode === 'function') {
            image.decode().catch(() => {}).then(afterPoster);
          } else {
            afterPoster();
          }
        };
        listen(image, 'load', finish, { once: true });
        listen(image, 'error', finish, { once: true });
        if (!poster) image.src = video.poster;
        if (image.complete) finish();
      }
      state.cleanup = () => {
        state.stopped = true;
        controller.abort();
        if (state.observer) state.observer.disconnect();
        cancelAnimationFrame(state.frame);
        if (state.videoFrame !== null && video.cancelVideoFrameCallback) {
          video.cancelVideoFrameCallback(state.videoFrame);
        }
        video.pause();
      };
      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          state.observer.disconnect();
          prepare();
        }, { rootMargin: '200px' });
        state.observer.observe(video);
      } else {
        prepare();
      }
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, video) => {
      if (event.target.contains(video)) {
        state.cleanup();
        states.delete(video);
      }
    });
  });
})();
